import {initCustomEvents} from "./assets/js/utils/events";
import {initDomPrototypes} from "./assets/js/utils/dom";
import {Loader} from "./assets/js/modules/loader";
var imagesLoaded = require('imagesloaded');

/**
 * Here you find all methods available in /themes/soledad/main.js - But dynamically imported as required
 *
 * The following features are not imported as they are not used:
 *
 * - PENCI.masonary
 * - PENCI.mega_menu
 * - PENCI.video_background
 * - PENCI.Jarallax
 * - PENCI.gallery
 * - PENCI.RelatedPopup
 * - PENCI.fixheadline
 */

(function (global) {
    let booted = false, loader = null

    /**
     * Boot method. Order matters!
     *
     * @returns {number}
     */
    function boot() {
        // Avoid duplicate boots
        if(booted) {
            return 0;
        }
        booted = true;

        // Init the loader module
        loader = new Loader()

        // Add additional plugins
        imagesLoaded.makeJQueryPlugin( jQuery );

        // Init local utilities
        initCustomEvents()
        initDomPrototypes()

        // Add loader-watchers
        initLoaders()

        // Run global executables (search toggle, ...)
        runGlobalHandlers(jQuery)
    }

    /**
     * Main Handlers as copied from soledad/js/main.js => PENCI.general
     * @param $
     */
    function runGlobalHandlers($) {

        // $( '#top-search a.search-click' ).on( 'click', function () {
        //     // $( '.show-search' ).fadeToggle();
        //     // $( '.show-search input.search-input' ).focus();
        // } );

        // Go to top
        $( '.go-to-top, .penci-go-to-top-floating' ).on( 'click', function () {
            $( 'html, body' ).animate( { scrollTop: 0 }, 700 );
            return false;
        } );

        // Go to top button
        var $goto_button = $( '.penci-go-to-top-floating' );
        if ( $goto_button.length ) {
            $(document).scroll(function() {
                var y = $(this).scrollTop();
                if ( y > 300) {
                    $goto_button.addClass('show-up');
                } else {
                    $goto_button.removeClass('show-up');
                }
            } );
        }

        // Call back fitvid when click load more button on buddypress
        $( 'body.buddypress .activity .load-more a' ).on( 'click', function () {
            $(document).ajaxStop(function() {
                $( ".container" ).fitVids();
            });
        } );

        // Passive event listeners
        $.event.special.touchstart = {
            setup: function( _, ns, handle ) {
                this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
            }
        };
        $.event.special.touchmove = {
            setup: function( _, ns, handle ) {
                this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
            }
        };
        $.event.special.wheel = {
            setup: function( _, ns, handle ){
                this.addEventListener("wheel", handle, { passive: true });
            }
        };
        $.event.special.mousewheel = {
            setup: function( _, ns, handle ){
                this.addEventListener("mousewheel", handle, { passive: true });
            }
        };
    }

    /**
     * Register import-methods that load javascript modules when node is visible / scrolled into view
     */
    function initLoaders() {

        // Lazyloading Images
        loader.watch(
            {
                selector: '.penci-lazy',
                _cb: (node) => {
                    import('./assets/js/modules/LazyLoad/lazyload').then(a => {
                        a.initLazyLoad(global)
                        jQuery('.penci-lazy').Lazy({ effect: 'fadeIn',  effectTime: 300, scrollDirection: 'both' });
                    })
                }
            }
        )

        // Front-page featured slider
        loader.watch(
            {
                selector: '.penci-owl-featured-area',
                _cb: () => import('./assets/js/modules/OwlCarousel/featured-slider').then(a => a.initFeaturedSlider(jQuery)),
                func: 'querySelector'
            }
        )

        // Default owl carousel
        // Todo: Test!
        loader.watch(
            {
                selector: '.penci-owl-carousel-slider',
                _cb: () => import('./assets/js/modules/OwlCarousel/owl-slider').then(a => a.initOwlSlider(jQuery)),
                func: 'querySelector'
            }
        )

        // Import sticky module if scroll is not at start, else attach scroll listener to import module
        loader.watch(
            {
                onTotalScroll: 100,
                _cb: () => import('./assets/js/modules/Sticky/sticky').then(a => a.initSticky(jQuery))
            }
        )


        // Load Sticky sidebar when sidebar's top is close to window top
        loader.watch(
            {
                selector: 'sidebar',
                func: 'getElementById',
                distanceToTop: 5,
                _cb: () => import('./assets/js/modules/StickySidebar/sticky-sidebar').then(a => a.initStickySidebar(jQuery))
            }
        )

        // Load Mobile Nav
        // Todo: Maybe only import when nav button is clicked? Might be too slow though
        loader.watch(
            {
                underScreenWidth: 961,
                _cb: () => import('./assets/js/modules/MobileMenu/mobile-menu').then(a => a.initMobileToggle(jQuery))
            }
        )

        // Load MagnifiPopup Lightbox
        loader.watch(
            {
                selector: 'a[data-rel^="penci-gallery-image-content"]',
                _cb: () => import('./assets/js/modules/MagnificPopup/magnific-popup').then(a => a.initMagnificPopups(jQuery))
            }
        )

        // Some Cookie Thing
        loader.watch(
            {
                selector: '.penci-wrap-gprd-law',
                _cb: () => import('./assets/js/modules/Cookie/cookie').then(a => a.initCookie(jQuery))
            }
        )

        // Set src-attribute on asset-intense sidebar widget
        loader.watch(
            {
                viewportOffset: 100,
                selector: 'searchformwidget',
                func: 'getElementById',
                _cb: (node) => {
                    if(!node.getAttribute('src')) {
                        node.setAttribute('src', node.dataset.src)
                    }
                }
            }
        )


        loader.run()
    }



    //==|===============================================================================
    //  |  Boot!!
    //--V-------------------------------------------------------------------------------

    if(document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot)
    } else {
        boot();
    }

})(window);
